import React from 'react';

import Box from 'relements/build/esm/ui/box';
import Toggle from 'relements/build/esm/input/toggle';
import Text from 'relements/build/esm/ui/text';
import Dropdown from 'relements/build/esm/input/dropdown';
import TextInput from 'relements/build/esm/input/text';
import Icon from 'relements/build/esm/ui/icon';
import TextHSL from '@haptik/helpers/build/esm/TextHSL';
import InfoIconV4 from 'relements/build/esm/ui/icons/InfoIconV4';
import Tooltip from 'relements/build/esm/overlays/tooltip';

import HSLDisplay from '@haptik/helpers/build/esm/hslDisplay';

import {
  StyledTextHSLContainer,
  UserDetailsContainer,
} from '../StyledComponents';
import { ACTIONS } from '../const';

const Label = ({ text, marginTop = 0, marginBottom = 0, info = '' }) => {
  return (
    <Box padding="0">
      <Text color="text" variant="body.md" style={{ marginTop, marginBottom }}>
        {text}
      </Text>
      <Tooltip themed tooltip={info} position="TOP">
        <InfoIconV4 size="small" iconColor="grey.dark" marginLeft="4px" />
      </Tooltip>
    </Box>
  );
};

function UserDetailsFilter({
  hslValue,
  handleChangeUserDetailsFilter,
  userDetailsToggle,
  userKey,
  catalogFilterKey,
  catalogFilterList = [],
  errors,
  disabled,
}) {
  return (
    <UserDetailsContainer
      padding="12px"
      marginTop="24px"
      flexDirection="column"
      width="492px"
    >
      <Box padding="0" width="100%" justifyContent="space-between">
        <Text color="black.haptik" variant="h3.semi-bold">
          User Detail Based Filtering
        </Text>

        <Toggle
          disabled={disabled}
          value={userDetailsToggle}
          onChange={(value) => {
            handleChangeUserDetailsFilter(value, ACTIONS.SET_FILTER_TOGGLE);
          }}
        />
      </Box>

      {userDetailsToggle && (
        <>
          <Box padding="0" style={{ gap: '16px' }} marginTop="24px">
            <Box padding="0" flexDirection="column" width="50%">
              <TextInput
                disabled={disabled}
                error={errors.userKey}
                themed
                label={
                  <Label
                    text="User key"
                    info="User detail key based on which products need to be filtered from the catalog"
                  />
                }
                placeholder="User key"
                onChange={(value) => {
                  handleChangeUserDetailsFilter(value, ACTIONS.SET_USER_KEY);
                }}
                value={userKey}
              />
            </Box>
            <Box padding="0" flexDirection="column" width="50%">
              <Dropdown
                disabled={disabled}
                withSearch
                themed
                placeholder="Catalog store filter key"
                options={catalogFilterList}
                label={
                  <Label
                    text="Catalog store filter key"
                    info="Catalog header where user detail value is to be present"
                  />
                }
                value={catalogFilterKey}
                onChange={(val) => {
                  handleChangeUserDetailsFilter(
                    val,
                    ACTIONS.SET_CATALOG_STORE_FILTER_KEY
                  );
                }}
              />
            </Box>
          </Box>

          <StyledTextHSLContainer>
            <Box padding="0" marginBottom="24px">
              <Icon src={'bot-says-colored'} />

              <Text
                color="black.haptik"
                variant="h3.semi-bold"
                style={{ marginLeft: '12px' }}
              >
                Error Bot Response
              </Text>

              <Tooltip
                themed
                tooltip={
                  'Error response & QRs to be shown when user key is not updated in user detail'
                }
                position="TOP"
              >
                <InfoIconV4
                  size="small"
                  iconColor="grey.dark"
                  marginLeft="4px"
                />
              </Tooltip>
            </Box>

            {disabled ? (
              <HSLDisplay value={JSON.stringify(hslValue)} />
            ) : (
              <TextHSL
                value={hslValue}
                onChange={(value) => {
                  handleChangeUserDetailsFilter(value, ACTIONS.SET_HSL);
                }}
              />
            )}

            {errors.hsl && (
              <Box padding="0" flexDirection="column" marginTop="7px">
                <Text variant="h4.semi-bold" color="red.haptik">
                  {errors.hsl}
                </Text>
              </Box>
            )}
          </StyledTextHSLContainer>
        </>
      )}
    </UserDetailsContainer>
  );
}

export default UserDetailsFilter;
